import { Injectable } from '@angular/core';
import { createEffect } from '@ngrx/effects';
import { DataPersistence } from '@nrwl/nx';
import { map } from 'rxjs/operators';

import { ImportPartialState, ImportActions } from './import.state';
import { ImportService } from '../data-access.service';

@Injectable()
export class  ImportEffects {

  loadAllEntities$ = createEffect(() => this.dataPersistence.fetch(ImportActions.LoadAll.type, {
    run: (action: any, state) => this.apiService.getAll(action.payload)
                                      .pipe(map(response => ImportActions.LoadedAll({ payload: response }))),
    onError: (action: any, error) => ImportActions.ActionError(action + error)
  }));

  createEntity$ = createEffect(() => this.dataPersistence.pessimisticUpdate(ImportActions.Add.type, {
    run: (action: any, state) => this.apiService.add(action.payload)
                                      .pipe(map((response: any) => ImportActions.Added({ payload: response }))),
    onError: (action: any, error) => ImportActions.ActionError(action + error)
  }));

  updateEntity$ = createEffect(() => this.dataPersistence.pessimisticUpdate(ImportActions.Update.type, {
    run: (action: any, state) => this.apiService.update(action.payload)
                                      .pipe(map((response: any) => ImportActions.Updated({ payload: response }))),
    onError: (action: any, error) => ImportActions.ActionError(action + error)
  }));

  deleteEntity$ = createEffect(() => this.dataPersistence.pessimisticUpdate(ImportActions.Delete.type, {
    run: (action: any, state) => this.apiService.delete(action.payload)
                                      .pipe(map(response => ImportActions.Deleted({ payload: response }))),
    onError: (action: any, error) => ImportActions.ActionError(action + error)
  }));

  constructor(
    private dataPersistence: DataPersistence<ImportPartialState>,
    private apiService: ImportService,
  ) {}
}
// console.log(`%cImportEffects::ngOnInit`, 'background:yellow');
